module.exports = __webpack_public_path__ + "img/generic.f622546c.png";